export default function BlurredZeroValue({ value }) {
	return <span style={{ opacity: value == 0 ? '0.2' : '1' }}>{value}</span>;
}